import validateVar from "./validation/validateVariable";

function getCancellationDisplay(pre_provider) {
    let has_pre_provider = validateVar(pre_provider);

    if(has_pre_provider) return 'Kündigung durch Anbieter';
    return 'Kündigung durch Kunden';
}

export default getCancellationDisplay;